const displayPrice = (price) => parseFloat(price)
  .toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default displayPrice;
